import { render, staticRenderFns } from "./Trainer.vue?vue&type=template&id=65856888&scoped=true"
import script from "./Trainer.vue?vue&type=script&lang=js"
export * from "./Trainer.vue?vue&type=script&lang=js"
import style0 from "./Trainer.vue?vue&type=style&index=0&id=65856888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65856888",
  null
  
)

export default component.exports